import Resizer from "react-image-file-resizer";
import api from "../utils/api";
import QRCode from "qrcode";

// import { toast } from "react-toastify";
// toast.configure();
import { Buffer } from "buffer";
window.Buffer = Buffer;

var CryptoJS = require("crypto-js");
var aesEcb = require("aes-ecb");

// const apiURL = process.env.REACT_APP_DEV_ENVIROMET_URL === "DEV"
//   ? "https://dev.azaleaonline.com/AzaleaAPI"
//   : "";

const runtimeEnv = window?.ENV || "DEV";
console.log("runtimeEnv", runtimeEnv);
const environmentApiUrls = {
  DEV: "https://dev.azaleaonline.com/AzaleaAPI",
  STG: "https://stg.azaleaonline.com/AzaleaAPI",
  PRE_PROD: "https://pre_prod.azaleaonline.com/AzaleaAPI",
  PROD: "https://azaleaonline.com/AzaleaAPI",
};

const apiURL = environmentApiUrls[runtimeEnv] || environmentApiUrls.DEV;

const sendHttpRequest = (
  url,
  baseUrl,
  body,
  method,
  reqParams = "",
  reqJWT,
  jwt,
  needDecryption = false,
  skipGlobalLoader = false,
  responseType = "",
  accept = "application/json",
) => {
  const methodUpper = String(method || "").toUpperCase();
  const isFormData =
    typeof FormData !== "undefined" && body instanceof FormData;
  const headers = {
    accept,
    APP_ID: process.env.REACT_APP_DEV_APP_ID,
  };

  if (!isFormData) {
    headers["Content-Type"] = "application/json";
  }

  if (reqJWT === true && jwt) {
    headers.Authorization = `Bearer ${jwt}`;
  }

  let ciphertext = body;
  if (
    methodUpper !== "GET" &&
    needDecryption &&
    !isFormData &&
    ciphertext &&
    Object.keys(ciphertext).length !== 0
  ) {
    ciphertext = AESEncrypt(ciphertext);
  }

  let finalReqParams = reqParams !== "" ? String(reqParams) : "";
  if (methodUpper === "GET" && body && typeof body === "object") {
    const queryObject = {};
    Object.keys(body).forEach((key) => {
      const value = body[key];
      if (value !== undefined && value !== null && value !== "") {
        queryObject[key] = value;
      }
    });
    const bodyQuery = new URLSearchParams(queryObject).toString();
    finalReqParams =
      [finalReqParams, bodyQuery]
        .filter((part) => String(part).trim())
        .join("&") || "";
    ciphertext = undefined;
  }

  const finalUrl =
    apiURL + "/" + url + (finalReqParams !== "" ? "?" + finalReqParams : "");

  return api
    .fetchRequest(
      method,
      headers,
      ciphertext,
      finalUrl,
      skipGlobalLoader,
      responseType,
    )
    .then((response) => {
      if (needDecryption && responseType !== "blob") {
        const decrypted = AESDecrypt(response.data);
        return { ...response, data: decrypted };
      }
      return response;
    })
    .catch((error) => error);
};

const getResponseStatus = (response) => Number(response?.status);

const isSuccessResponse = (response) =>
  [200, 201].includes(getResponseStatus(response));

const controller = (
  url,
  body,
  method,
  reqParams,
  needAuthentication,
  jwt,
  needDecryption,
  skipGlobalLoader = false,
  responseType = "",
  accept = "application/json",
) => {
  return sendHttpRequest(
    url,
    apiURL,
    body,
    method,
    reqParams,
    needAuthentication,
    jwt,
    needDecryption,
    skipGlobalLoader,
    responseType,
    accept,
  );
};

function extractAppointmentDataFromUrl(url) {
  const startMarker = "euLUpj0cPhoYeh/Yn0ce9Q==";
  const endMarker = "aJ/mgkVbX08uhCqZnaqr7A==";

  const startIndex = url.indexOf(startMarker);
  const endIndex = url.indexOf(endMarker);

  if (startIndex !== -1 && endIndex !== -1 && startIndex < endIndex) {
    return url.substring(startIndex + startMarker.length, endIndex);
  } else {
    return null; // Return null if markers are not found or in the wrong order
  }
}
function extractResubmitionDta(url) {
  const startMarker = "WVNgKeASE191cD1TKmk4g==";
  const endMarker = "86eQ1qMx/mk/6X0mQJ7H8g==";

  const startIndex = url.indexOf(startMarker);
  const endIndex = url.indexOf(endMarker);

  if (startIndex !== -1 && endIndex !== -1 && startIndex < endIndex) {
    return url.substring(startIndex + startMarker.length, endIndex);
  } else {
    return null; // Return null if markers are not found or in the wrong order
  }
}
const convertBase64 = async (file) => {
  if (file !== "" && file !== null && file instanceof Blob) {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  } else {
    return "";
  }
};

function AESEncrypt(pureText) {
  return aesEcb.encrypt(
    process.env.REACT_APP_ECYPTION_KEY,
    JSON.stringify(pureText),
  );
}

function AESDecrypt(encryptedText) {
  const cryptkey = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_ECYPTION_KEY);
  var crypted = hexToBase64(encryptedText);
  var decrypt = CryptoJS.AES.decrypt(crypted, cryptkey, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  decrypt = decrypt.toString(CryptoJS.enc.Utf8);

  try {
    decrypt = JSON.parse(decrypt);
    return decrypt;
  } catch (e) {
    return decrypt;
  }
}

function hexToBase64(hexstring) {
  return btoa(
    hexstring
      .match(/\w{2}/g)
      ?.map(function (a) {
        return String.fromCharCode(parseInt(a, 16));
      })
      .join(""),
  );
}

const decodeBase64 = async (path) => {
  let base64ToString = new Buffer(path, "base64");

  return base64ToString.toString("ascii");
};
const parseJwt = (token) => {
  if (token !== null && token !== undefined) {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        ?.map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join(""),
    );

    return JSON.parse(jsonPayload);
  } else {
    window.location.href = "/";
  }
};

const isUuid = (value) =>
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
    String(value || "").trim(),
  );

const getUserIdFromJwt = (tokenOrPayload) => {
  const payload =
    typeof tokenOrPayload === "string"
      ? parseJwt(tokenOrPayload)
      : tokenOrPayload;

  const candidates = [
    payload?.userID,
    payload?.userId,
    payload?.user_id,
    payload?.uid,
    payload?.sub,
    payload?.id,
  ];

  return candidates.find((value) => isUuid(value)) || "";
};

const resizeFile = async (file) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      300,
      300,
      "JPEG",
      100,
      0,
      (uri) => {
        resolve(uri);
      },
      "base64",
    );
  });

const filterCountryOption = (countries) => {
  return (option, inputValue) => {
    try {
      const country = countries.find((c) => c.dialCode === option.data.value);

      if (!country) return false;

      const search = inputValue.toLowerCase();

      return (
        country.label.toLowerCase().includes(search) ||
        country.code.toLowerCase().includes(search) ||
        country.dialCode.includes(search)
      );
    } catch (error) {
      console.error("Country filter error:", error);
      return false;
    }
  };
};

const checkEmailFormat = (email) => {
  try {
    const emailpattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailpattern.test(email);
  } catch (error) {
    console.log(error);
    return false;
  }
};

const checkPasswordFormat = (password) => {
  try {
    return {
      length: password.length >= 8,
      uppercase: /[A-Z]/.test(password),
      lowercase: /[a-z]/.test(password),
      digit: /[0-9]/.test(password),
      special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
      allValid:
        password.length >= 8 &&
        /[A-Z]/.test(password) &&
        /[a-z]/.test(password) &&
        /[0-9]/.test(password) &&
        /[!@#$%^&*(),.?":{}|<>]/.test(password),
    };
  } catch (error) {
    console.error("Password validation error:", error);
    return {
      length: false,
      uppercase: false,
      lowercase: false,
      digit: false,
      special: false,
      allValid: false,
    };
  }
};

// utils/fileUtils.js

const generateFileId = () => crypto.randomUUID?.() || Date.now().toString();

/**
 * Convert file to base64
 */
const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    try {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    } catch (error) {
      reject(error);
    }
  });
};

/**
 * Validate uploaded image
 */
const validateImageFile = (file, maxSizeMB = 8) => {
  if (!file) return { valid: false, message: "No file selected" };

  if (!file.type.startsWith("image/")) {
    return { valid: false, message: "Only image files are allowed" };
  }

  if (file.size > maxSizeMB * 1024 * 1024) {
    return { valid: false, message: `Max file size is ${maxSizeMB}MB` };
  }

  return { valid: true };
};

/**
 * Full helper to handle file upload → { id, name, base64 }
 */
const processImageFile = async (file, maxSizeMB = 50) => {
  const validation = validateImageFile(file, maxSizeMB);
  if (!validation.valid) {
    throw new Error(validation.message);
  }

  const base64 = await fileToBase64(file); // convert to full DataURL
  const pureBase64 = base64.split(",")[1]; // strip the prefix

  return {
    id: generateFileId(),
    name: file.name,
    base64: pureBase64, // raw Base64 only
  };
};

const validateVideoFile = (file, maxSizeMB = 200) => {
  if (!file) return { valid: false, message: "No file selected" };
  if (!file.type.startsWith("video/")) {
    return { valid: false, message: "Only video files are allowed" };
  }
  if (file.size > maxSizeMB * 1024 * 1024) {
    return { valid: false, message: `Max file size is ${maxSizeMB}MB` };
  }
  return { valid: true };
};

const processVideoFile = async (file, maxSizeMB = 200) => {
  const validation = validateVideoFile(file, maxSizeMB);
  if (!validation.valid) {
    throw new Error(validation.message);
  }
  const base64 = await fileToBase64(file);
  const pureBase64 = base64.split(",")[1];
  return {
    id: generateFileId(),
    name: file.name,
    base64: pureBase64,
  };
};
const base64ToQRCode = async (base64String) => {
  if (!base64String) throw new Error("Base64 string is required");

  try {
    const qrDataUrl = await QRCode.toDataURL(base64String);
    return qrDataUrl; // Returns a Data URL for <img>
  } catch (err) {
    throw new Error("Failed to generate QR code: " + err.message);
  }
};
const padBase64 = (base64) => {
  const mod = base64.length % 4;

  if (mod === 0) return base64;

  return base64 + "=".repeat(4 - mod);
};
// const imageUrlToBase64 = async (url) => {
//   try {
//     const response = await fetch(url);

//     if (!response.ok) {
//       throw new Error("Failed to fetch image");
//     }

//     const blob = await response.blob();

//     return await new Promise((resolve, reject) => {
//       const reader = new FileReader();

//       reader.onloadend = () => resolve(reader.result);
//       reader.onerror = reject;

//       reader.readAsDataURL(blob);
//     });
//   } catch (error) {
//     console.error("Error converting image to Base64:", error);
//     return null;
//   }
// };
const cleanImageUrl = (url) => {
  if (!url) return null;

  return url

    .trim()

    .replace(/^['"]+|['"]+$/g, "") // remove wrapping quotes

    .replace(/(%27|')+$/g, "") // remove encoded or real quote at end

    .replace(/(%22|")+$/g, ""); // remove encoded or real double quote at end
};

const imageUrlToBase64 = async (url) => {
  try {
    const cleanedUrl = cleanImageUrl(url);

    const response = await fetch(cleanedUrl, {
      method: "GET",

      mode: "cors",
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch image. Status: ${response.status}`);
    }

    const blob = await response.blob();

    return await new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onloadend = () => resolve(reader.result);

      reader.onerror = reject;

      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error("Error converting image to Base64:", error);

    return null;
  }
};
function AESDecryptNavigation(encryptedText) {
  if (!encryptedText) return "";

  const decrypted = aesEcb.decrypt(
    process.env.REACT_APP_ECYPTION_KEY,
    encryptedText,
  );

  try {
    return JSON.parse(decrypted);
  } catch (error) {
    return decrypted;
  }
}
function jsonToTextList(data) {
  const obj = typeof data === "string" ? JSON.parse(data) : data;

  if (!obj || typeof obj !== "object") {
    return String(data);
  }

  return Object.entries(obj)
    .flatMap(([key, value]) => {
      if (Array.isArray(value)) {
        return value.map((item) => `${key}: ${item}`);
      }

      return `${key}: ${value}`;
    })
    .join("\n");
}
class TableNavigationDTO {
  constructor({ filters = {} } = {}) {
    this.filters = filters;
  }
}

const createTableNavigationState = (filters = {}) => {
  const tableState = new TableNavigationDTO({
    filters,
  });

  return AESEncrypt(JSON.stringify(tableState));
};

const getTableNavigationState = (encryptedState) => {
  if (!encryptedState) {
    return new TableNavigationDTO();
  }

  try {
    const decryptedState = AESDecryptNavigation(encryptedState);
    const parsedState =
      typeof decryptedState === "string"
        ? JSON.parse(decryptedState)
        : decryptedState;

    return new TableNavigationDTO(parsedState);
  } catch (error) {
    console.error("Failed to decrypt table navigation state:", error);

    return new TableNavigationDTO();
  }
};

export default {
  jsonToTextList,
  filterCountryOption,
  checkEmailFormat,
  checkPasswordFormat,
  fileToBase64,
  generateFileId,
  validateImageFile,
  processImageFile,
  validateVideoFile,
  processVideoFile,
  sendHttpRequest,
  getResponseStatus,
  isSuccessResponse,
  controller,
  base64ToQRCode,
  parseJwt,
  getUserIdFromJwt,
  padBase64,
  extractAppointmentDataFromUrl,
  imageUrlToBase64,
  AESDecrypt,
  AESEncrypt,
  AESDecryptNavigation,
  createTableNavigationState,
  getTableNavigationState,
  TableNavigationDTO,
};
